module.exports = __webpack_public_path__ + "img/image-11.b7440276.jpeg";